"use client";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Button } from "@/components/ui/button";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import dynamic from "next/dynamic";
import React from "react";
const EditorComponent = dynamic(() => import("@/components/admin/BlockNote"), {
    ssr: false,
});
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    assets: IAccountAssets[] | undefined;
    account_id: string;
    impersonate?: any;
}
export default function RichTextBlockOptions({
    block,
    blockUpdate,
    update,
    assets,
    account_id,
    impersonate,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [content, setContent] = React.useState(block.options.content);
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting noBorder>
                <div className="flex flex-col gap-3">
                    <div className="flex max-h-phoneHeight flex-col gap-3 overflow-y-auto overflow-x-hidden">
                        <EditorComponent
                            key={block.id}
                            id={block.id}
                            value={content}
                            onChange={(e) => {
                                setContent(e);
                            }}
                            assets={assets}
                            account_id={account_id}
                            brand_id={impersonate ? impersonate.id : null}
                        />
                    </div>
                    <Button
                        className="ml-auto w-fit"
                        onClick={() => {
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    content: content,
                                },
                            });
                        }}
                    >
                        Save
                    </Button>
                </div>
            </CardSetting>
        </div>
    );
}
